const DashboardLanding = (props) => {
  return (
    <p>Landing page for dashboard - employee</p>
  );
}
export default DashboardLanding;